import MenuList from '@material-ui/core/MenuList';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';
import React from 'react';
import AddToCalendarHOC, { SHARE_SITES } from 'react-add-to-calendar-hoc';

import Button from '../../../../components/Button';
import { IEventItem } from '../../../../store/player/events/store';

interface IProps {
  item: IEventItem;
  onCancel: () => void;
}

const AddToCalendarDropdown = AddToCalendarHOC(Button, MenuList);

const EventMessageSent = ({ item, onCancel }: IProps) => {
  const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const startDate = moment(item.start).utc();
  const endDate = moment(item.end).utc();
  const duration = moment
    .duration(endDate.diff(startDate))
    .asHours()
    .toString();
  const location =
    typeof item.club !== 'number' ? item.club.course.address.replace(/\n|\r/g, '') : '';
  const event = {
    description: item.description || '',
    duration,
    endDatetime: endDate.format('YYYYMMDDTHHmmssZ'),
    location,
    startDatetime: startDate.format('YYYYMMDDTHHmmssZ'),
    title: item.name || ''
  };

  return (
    <div className="event-checkout wrapper">
      <div className="event-success">
        <Paper elevation={1} className="paper">
          <h4>YOUR MESSAGE WAS SENT</h4>

          <AddToCalendarDropdown
            className="calendar-button-container"
            buttonProps={{
              className: 'button button-shadow',
              color: 'primary',
              id: 'success-continue',
              variant: 'outlined'
            }}
            dropdownProps={{
              className: 'button calendar-dropdown-container'
            }}
            buttonText="Add to calendar"
            event={event}
            items={
              isiOS
                ? [SHARE_SITES.GOOGLE, SHARE_SITES.ICAL, SHARE_SITES.YAHOO]
                : [SHARE_SITES.GOOGLE, SHARE_SITES.ICAL, SHARE_SITES.OUTLOOK, SHARE_SITES.YAHOO]
            }
          />

          <Button color="primary" className="button" onClick={onCancel} id="success-cancel">
            GO TO EVENT PAGE
          </Button>
        </Paper>
      </div>
    </div>
  );
};

export { EventMessageSent };
